import React from 'react';
import { TextField, type TextFieldProps } from '@mui/material';

/** A number input that reports numbers (or null when cleared). */
export const NumField: React.FC<Omit<TextFieldProps, 'onChange' | 'value'> & {
  value: number | null | undefined;
  onChange: (v: number | null) => void;
}> = ({ value, onChange, ...rest }) => (
  <TextField
    size="small"
    type="number"
    value={value ?? ''}
    onChange={(e) => onChange(e.target.value === '' ? null : Number(e.target.value))}
    inputProps={{ 'aria-label': typeof rest.label === 'string' ? rest.label : undefined, step: 'any' }}
    {...rest}
  />
);

/** A YYYY-MM-DD date input. */
export const DateField: React.FC<Omit<TextFieldProps, 'onChange' | 'value'> & {
  value: string | undefined;
  onChange: (v: string) => void;
}> = ({ value, onChange, ...rest }) => (
  <TextField
    size="small"
    type="date"
    value={value ?? ''}
    onChange={(e) => onChange(e.target.value)}
    InputLabelProps={{ shrink: true }}
    inputProps={{ 'aria-label': typeof rest.label === 'string' ? rest.label : undefined }}
    {...rest}
  />
);

/** Immutable update helper: clone, mutate the clone, return it. */
export function produce<T>(value: T, fn: (draft: T) => void): T {
  const draft = structuredClone(value);
  fn(draft);
  return draft;
}
